module.exports = __webpack_public_path__ + "static/media/Reserve.54c9f71c.png";